import { ReactElement } from 'react';
import { Checkbox } from 'common/components/antd/Checkbox/Checkbox';
import { Form } from 'common/components/antd/Form/Form';
import { SContainer } from './checkbox-cell.style';
import { KEY_SEPARATOR } from '../../table.constants';
import { TPermissionRecord, TScopeRecord, TTableColumn } from '../../table.types';
import { isIndeterminate, isScopeRecord } from '../../table.utils';

export const CheckboxCellComponent = ({
  record,
  column,
}: {
  record: TScopeRecord | TPermissionRecord;
  column: TTableColumn;
}): ReactElement | null => {
  if (isScopeRecord(record) && !record.children.length) {
    return null;
  }
  return (
    <SContainer>
      <Form.Item
        valuePropName="checked"
        noStyle
        name={(isScopeRecord(record) ? [column.key, record.key] : [column.key, record.scopeKey, record.key]).join(
          KEY_SEPARATOR,
        )}
      >
        <Checkbox indeterminate={isIndeterminate(record, column)} />
      </Form.Item>
    </SContainer>
  );
};
